import * as React from 'react';
import {
  AppBar,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  IconButton,
  Slide,
  Toolbar,
  Typography,
  useMediaQuery,
} from '@mui/material';
import { TransitionProps } from '@mui/material/transitions';
import { WhatWeCantTreat } from '../app/menu/what-we-cant-treat';
import { Icon } from '../icon/icon';
import { theme } from '../../styles/theme';

const Transition = React.forwardRef(
  (
    props: TransitionProps & {
      children: React.ReactElement;
    },
    ref: React.Ref<unknown>
  ) => <Slide direction="up" ref={ref} {...props} />
);

const WhatWeCantTreatDialog = () => {
  const [open, setOpen] = React.useState(false);

  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <Button sx={{ mt: 1, pl: 0 }} variant="text" onClick={handleClickOpen}>
        What we can't treat
      </Button>
      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
      >
        <AppBar sx={{ position: 'relative' }}>
          <Toolbar>
            {fullScreen && (
              <IconButton
                style={{ color: 'white' }}
                edge="start"
                onClick={handleClose}
                aria-label="close"
              >
                <Icon
                  icon="ChevronDown"
                  color="inherit"
                  fontSize="small"
                  styleType="regular"
                />
              </IconButton>
            )}
            <Typography
              sx={{ ml: fullScreen ? 2 : 0, flex: 1 }}
              variant="h6"
              component="div"
            >
              What we can't treat
            </Typography>
          </Toolbar>
        </AppBar>
        <DialogContent>
          <WhatWeCantTreat />
        </DialogContent>
        {!fullScreen && (
          <DialogActions>
            <Button onClick={handleClose} color="primary">
              Close
            </Button>
          </DialogActions>
        )}
      </Dialog>
    </div>
  );
};

export default WhatWeCantTreatDialog;
